export { QuizSection } from "./Quiz";
